import React from 'react';
import {Flex, Text} from "@chakra-ui/layout";
import {Link} from "@chakra-ui/react";
import {NavLink} from "react-router-dom";

export type AuthLinkDetails = {
  name: string;
  studentLink: string;
  tutorLink: string;
}

function AuthLink({name, studentLink, tutorLink}: AuthLinkDetails) {
  return (
    <>
      <Text fontSize={24} fontWeight={600} m={"24px 0"} textTransform={"capitalize"}>{name}</Text>
      <Flex flexDirection={"row"} textAlign={"center"} justifyContent={"center"}>
        <Link as={NavLink} to={studentLink} p={{base: "10px 30px", lg: "17px 60px"}}
              bgColor={"brand.lightGreen"}
              color={"brand.darkGreen"} textTransform={"capitalize"} mr={"5px"} borderRadius={"10px"} fontWeight={600}>
          student
        </Link>
        <Link as={NavLink} to={tutorLink} p={{base: "10px 30px", lg: "17px 60px"}}
              bgColor={"brand.orange"}
              color={"brand.gold"} textTransform={"capitalize"} ml={"5px"} borderRadius={"10px"} fontWeight={600}>
          teacher
        </Link>
      </Flex>
    </>
  );
}

export default AuthLink;